<template>
    <div>
        <v-tooltip title="Помощь" :x-diff="-60">
            <div
                id="help"
                class="help js-float-tooltip d-none d-md-block"
                data-title="Помощь"
                @click="openModal"
            ></div>
        </v-tooltip>

        <modal
            :is-open="isModalOpen"
            :is-loading="loading"
            :disabled="loading"
            title="Помощь"
            btn-save-title="Отправить"
            :overlay-z-index="10000"
            :modal-z-index="10001"
            @onCloseModal="closeModal"
            @onSaveModal="saveModal"
        >
            Пожалуйста, опишите свою проблему максимально подробно, чтобы мы
            могли быстрее решить ее.
            <div class="cabinet-form-group">
                <textarea
                    id="message"
                    v-model="message"
                    class="cabinet-form-group__textarea cabinet-form-group__textarea--resizable"
                    :class="{
                        error:
                            ($v.message.$dirty && $v.message.$invalid) ||
                            errors.requestHelp.message
                    }"
                    placeholder="Чем мы можем вам помочь?"
                ></textarea>
                <div
                    v-if="$v.message.$dirty && $v.message.$invalid"
                    class="error-label"
                >
                    Добавьте описание
                </div>
                <div
                    v-if="errors.requestHelp.message && !$v.message.$dirty"
                    class="error-label"
                >
                    {{ errors.requestHelp.message[0] }}
                </div>
            </div>

            <!--
                <div v-if="screenshot" class="cabinet-form-group">
                    <label class="cabinet-cart-checkbox">
                        <input
                            v-model="isScreenShotAttached"
                            type="checkbox"
                            value="true"
                        />
                        <span class="cabinet-cart-checkbox__checkmark"></span>
                        Прикрепить снимок экрана
                    </label>
                </div>

                <div
                    v-if="isScreenShotAttached && screenshot"
                    class="help__screenshot"
                    :style="screenshotBg"
                ></div>
            -->

            <template v-if="!isDemoUser">
                <div
                    v-if="screenshot"
                    class="cabinet-form-group d-flex align-items-center"
                >
                    <div class="help__file help__info">
                        {{ screenshotName }}
                    </div>
                    <div
                        class="help__file-remove ml-2"
                        @click="removeImage"
                    ></div>
                </div>
                <div
                    v-else
                    class="cabinet-form-group d-flex align-items-center"
                >
                    <div class="pr-3">
                        <input
                            ref="imageFile"
                            type="file"
                            accept="image/jpeg,image/png,image/gif"
                            class="hide"
                            @change="uploadImage"
                        />
                        <button
                            class="cabinet-btn cabinet__catalog-button dashboard-list__btn mt-0"
                            @click="onAddImage()"
                        >
                            Загрузить файл
                        </button>
                    </div>
                    <div
                        class="help__info"
                        :class="{ error: screenshotSize > 2 }"
                    >
                        Файл в формате .jpg, .png, .gif и размером не более 2Мб
                    </div>
                </div>
            </template>
        </modal>
    </div>
</template>

<script>
import Modal from '@/components/Elements/Modal'
import { mapState, mapGetters, mapMutations, mapActions } from 'vuex'
import { required, maxLength } from 'vuelidate/lib/validators'
import checkDemoUser from '@/mixins/checkDemoUser.js'

import html2canvas from 'html2canvas'
import { takeScreenshotCanvas } from '@/utils/getDisplayMedia.js'

import jqScrollex from 'jquery.scrollex'

const validations = {
    message: {
        required,
        maxLength: maxLength(1000)
    }
}

export default {
    name: 'Help',
    components: { Modal },
    mixins: [checkDemoUser],
    data() {
        return {
            loading: false,
            message: '',
            isScreenShotAttached: true,
            screenshot: '',
            screenshotName: '',
            screenshotSize: null
        }
    },
    computed: {
        ...mapState('help', ['isModalOpen', 'modalTimeStamp', 'errors']),
        ...mapGetters('user', ['isSupplier']),
        screenshotBg() {
            if (!this.screenshot) return {}
            return {
                background:
                    'url(' + this.screenshot + ') no-repeat center center',
                'background-size': 'contain'
            }
        }
    },
    validations,
    watch: {
        modalTimeStamp: function(val) {
            this.openModal()
        }
    },
    mounted() {
        this.initScrollex()
    },
    methods: {
        ...mapMutations('help', ['SET_IS_MODAL_OPEN']),
        ...mapActions('help', ['requestHelp']),
        openModal() {
            // this.makeScreenshotDisplayMedia()
            this.SET_IS_MODAL_OPEN(true)
        },
        closeModal() {
            this.SET_IS_MODAL_OPEN(false)
            this.message = ''
            this.screenshot = ''
        },
        async saveModal() {
            if (this.loading) return

            this.$v.$touch()
            if (!this.$v.$invalid) {
                this.$v.$reset()
                this.loading = true

                let data = {
                    message: this.message
                }

                if (this.isScreenShotAttached && this.screenshot) {
                    data.screenshot = this.screenshot
                }

                if (this.isDemoUser) {
                    this.demoUserRequestHelp(data)
                    return
                }

                await this.requestHelp(data)

                if (Object.keys(this.errors.requestHelp).length) {
                    this.$notify({
                        type: 'error',
                        text: this.errors.requestHelp.error
                    })
                } else {
                    this.message = ''
                    this.screenshot = ''
                    this.closeModal()
                    this.$notify({
                        type: 'success',
                        text: 'Сообщение отправлено'
                    })
                }

                this.loading = false
            } else {
                console.log('Form not valid')
            }
        },
        makeScreenshot() {
            //not correct screenshot
            const element = document.body
            const opts = {}
            html2canvas(element, opts).then(canvas => {
                this.screenshot = canvas.toDataURL()
            })
        },

        async makeScreenshotDisplayMedia() {
            const canvas = await takeScreenshotCanvas()

            if (canvas) {
                this.screenshot = canvas.toDataURL()
            }

            this.SET_IS_MODAL_OPEN(true)
        },
        removeImage() {
            this.screenshot = ''
        },
        onAddImage() {
            this.$refs.imageFile.click()
        },
        uploadImage(e) {
            const image = e.target.files[0]
            this.screenshotName = image.name

            //in mb
            this.screenshotSize = image.size / 1024 / 1024

            if (this.screenshotSize <= 2) {
                const reader = new FileReader()
                reader.readAsDataURL(image)
                reader.onload = () => {
                    this.screenshot = reader.result
                }
            } else {
                this.$notify({
                    type: 'error',
                    text: 'Размер файла превышает 2Мб'
                })
            }
        },
        initScrollex() {
            const $footer = window.$('.copyright')
            const $help = window.$('#help')
            const $window = window.$('window')

            $window.on('resize', function() {
                $window.trigger('scroll')
            })

            $footer.scrollex({
                enter: function() {
                    $help.addClass('help--up')
                },
                leave: function() {
                    $help.removeClass('help--up')
                },
                terminate: function() {
                    $help.removeClass('help--up')
                }
            })
        },
        demoUserRequestHelp(data) {
            let subject = 'Новое сообщение в разделе Помощь в ДЕМО-режиме'
            window.open(
                'mailto:support@goldnet.market?subject=' +
                    subject +
                    '&body=' +
                    this.message
            )

            this.message = ''
            this.screenshot = ''
            this.closeModal()
            this.loading = false
        }
    }
}
</script>
